<template>
    <div v-if="editable" ref="dazone" :class="{'lam-small': (size === 'small')}" class="uk-text-center lam-file-upload">
        <div class="uk-placeholder">
            <open-icon v-if="(size !== 'small') && showUploadIcon" glyph="cloud-upload" size="medium" class="uk-text-muted uk-margin-small-right" />
            <slot v-if="!uploading" name="message-drag-or-click">
                Drop your file here or click to select it on your computer.
                <br><small>NOTE: you need to first save it as CSV from within Excel</small>
            </slot>
            <slot v-else name="message-uploading">
                Uploading your file...
            </slot>

            <input
                v-if="file_field_ready"
                type="file"
                ref="file"
                :accept="accepts"
                :disabled="disabled"
                @change="upload_single_file"
                class="nibnut-proxied-control"
            />
        </div>
    </div>
    <span v-else-if="!!value">
        <slot name="read_only">
            <a
                :href="value"
                title="View"
                target="_blank"
            >
                {{ label || value }}
            </a>
        </slot>
    </span>
    <span v-else class="uk-text-muted">
        <slot name="empty">(None)</slot>
    </span>
</template>

<script>
import notifies from "../mixins/Notifies"

import OpenIcon from "./OpenIcon"

const event_prevent_and_stop = event => {
    event.preventDefault()
    event.stopPropagation()
}

export default {
    mounted () {
        ["drag", "dragstart", "dragend", "dragover"].forEach(event_name => {
            if(this.$refs.dazone) this.$refs.dazone.addEventListener(event_name, event_prevent_and_stop)
        })

        if(this.$refs.dazone) {
            this.$refs.dazone.addEventListener("dragenter", this.drag_enter_handler)
            this.$refs.dazone.addEventListener("dragleave", this.drag_leave_handler)
            this.$refs.dazone.addEventListener("drop", this.drop_handler)
        }

        window.addEventListener("paste", this.paste)

        this.reset()
    },
    beforeDestroy () {
        try {
            window.removeEventListener("paste", this.paste)
            const events = ["drag", "dragstart", "dragend", "dragover"]
            events.forEach(event_name => {
                if(this.$refs.dazone) this.$refs.dazone.removeEventListener(event_name, event_prevent_and_stop)
            })

            if(this.$refs.dazone) {
                this.$refs.dazone.removeEventListener("dragenter", this.drag_enter_handler)
                this.$refs.dazone.removeEventListener("dragleave", this.drag_leave_handler)
                this.$refs.dazone.removeEventListener("drop", this.drop_handler)
            }
        } catch (exception) {
            // ignore...
        }
    },
    mixins: [notifies],
    components: {
        OpenIcon
    },
    methods: {
        reset () {
            this.uploading = false
        },
        drag_enter_handler (event) {
            event_prevent_and_stop(event)
            if(this.disabled) return
            this.height = this.$refs.dazone.offsetHeight
            this.dragging = true
        },
        drag_leave_handler (event) {
            event_prevent_and_stop(event)
            this.dragging = false
        },
        drop_handler (event) {
            event_prevent_and_stop(event)
            if(this.disabled) return
            this.upload(event.dataTransfer.files)
            this.dragging = false
        },
        paste (event) {
            if(!this.copyPastable) return
            if(event && !!event.clipboardData && !!event.clipboardData.items) {
                const items = Array.from(event.clipboardData.items)
                items.forEach(item => {
                    if(item.type.indexOf("image") !== -1) {
                        this.upload([item.getAsFile()])
                    }
                })
            }
        },
        upload_pick_file () {
            if(this.disabled) return
            this.$refs.file.click()
        },
        upload_single_file () {
            if(this.disabled) return
            this.upload(this.$refs.file.files)
            this.file_field_ready = false
            this.$nextTick(() => {
                this.file_field_ready = true
            })
        },
        upload (file_list) {
            if(this.disabled || !file_list || !file_list.length) return
            this.$emit("upload", file_list)
        }
    },
    props: {
        value: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal)$/i),
            default: "normal"
        },
        showUploadIcon: {
            type: Boolean,
            default: true
        },
        accepts: {
            type: String,
            default: ""
        },
        copyPastable: {
            type: Boolean,
            default: false
        },
        uploading: {
            type: Boolean,
            default: false
        },
        uploaded: {
            type: Number,
            default: 0
        },
        editable: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            dragging: false,
            file_field_ready: true,
            height: 0
        }
    }
}
</script>
